import React, { Component } from "react";
import { Input, Segment, Select, Checkbox, Button } from "semantic-ui-react";
import { connect } from "react-redux";

class PhoneNumbers extends Component {
  constructor(props) {
    super(props);

    this.phoneTypes = [
      {
        key: 0,
        value: "Mobile",
        text: "Mobile",
      },
      {
        key: 1,
        value: "Work",
        text: "Work",
      },
      {
        key: 2,
        value: "Home",
        text: "Home",
      },
    ];
  }

  errorsFor(field) {
    if (this.props.validation !== null) {
      if (typeof this.props.validation[field] !== "undefined") {
        return (
          <span className="has-error"> {this.props.validation[field][0]} </span>
        );
      }
    }
  }

  add() {
    const { user } = this.props;
    user.phoneNumbers.push({
      number: "",
      phoneType: "Work",
      primary: user.phoneNumbers.length === 0,
    });
    this.props.update(user);
  }

  remove(index) {
    const { user } = this.props;
    user.phoneNumbers.splice(index, 1);
    this.props.update(user);
  }

  onChangeNumber(value, index) {
    const { user } = this.props;
    user.phoneNumbers[index].number = value;
    this.props.update(user);
  }

  onChangePrimary(value, index) {
    const { user } = this.props;
    for (const phone of user.phoneNumbers) {
      phone.primary = false;
    }
    user.phoneNumbers[index].primary = value.checked;
    this.props.update(user);
  }

  onChangeType(result, index) {
    const { user } = this.props;
    user.phoneNumbers[index].phoneType = result.value;
    this.props.update(user);
  }

  list() {
    return this.props.user.phoneNumbers.map((phone, i) => {
      return (
        <div className="row mt-3" key={i}>
          <div className="col-sm-12 col-md-7 mb-2">
            <div className="row">
              <div className="col-6">
                <label className="with-input">Phone number</label>
                <Input
                  fluid
                  name={i}
                  placeholder="+44 123 456 789 / 07123 456 789"
                  value={phone.number}
                  onChange={(event) =>
                    this.onChangeNumber(event.target.value, i)
                  }
                />
              </div>
              <div className="col-6">
                <label className="with-input">Phone type</label>
                <Select
                  fluid
                  value={phone.phoneType}
                  options={this.phoneTypes}
                  name={i}
                  onChange={(_, result) => this.onChangeType(result, i)}
                  placeholder="Phone type"
                />
              </div>
            </div>
          </div>
          <div className="col-xs-12 col-md-5 text-right d-flex align-items-center justify-content-end">
            <Checkbox
              toggle
              label="Primary"
              value={i}
              checked={phone.primary}
              onChange={(_, value) => this.onChangePrimary(value, i)}
            />
            <Button
              primary
              className="red ml-3"
              value={i}
              onClick={() => this.remove(i)}
            >
              Remove
            </Button>
          </div>
        </div>
      );
    });
  }

  render() {
    return (
      <>
        <Segment vertical>
          {this.errorsFor("phoneNumbers")}
          <label className="with-input">Phone numbers</label>
          {this.list()}
          <div className="row">
            <div className="col-12">
              <Button
                primary
                className="theme mt-3"
                onClick={this.add.bind(this)}
              >
                Add phone number
              </Button>
            </div>
          </div>
        </Segment>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    validation: state.validation,
  };
}

export default connect(mapStateToProps)(PhoneNumbers);
